import * as bootstrap from 'bootstrap';
AOS.init();
jQuery('.open-popup-link').magnificPopup({
  type:'inline',
  midClick: true
});
jQuery('.testimonial-slider').slick({
  dots: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
});
document.addEventListener("DOMContentLoaded", function(){
  window.addEventListener('scroll', function() {
      if (window.scrollY > 50 && jQuery(window).width() > 991) {
        document.getElementById('navbar_top').classList.add('shrink_nav');
      } else {
        document.getElementById('navbar_top').classList.remove('shrink_nav');
      } 
  });
}); 
jQuery(".mfp-close").on('click', function(){
  console.log('test modal closed');
  stopVid();
});
function stopVid(){
  video.pause();
  video.currentTime = 0;
};
document.addEventListener("DOMContentLoaded", function(){
  window.bootstrap = bootstrap;
  document.querySelectorAll('.sidebar .nav-link').forEach(function(element){
    
    element.addEventListener('click', function (e) {

      let nextEl = element.nextElementSibling;
      let parentEl  = element.parentElement;	

        if(nextEl) {
            e.preventDefault();	
            let mycollapse = new bootstrap.Collapse(nextEl);
            
            if(nextEl.classList.contains('show')){
              mycollapse.hide();
            } else {
                mycollapse.show();
                // find other submenus with class=show
                var opened_submenu = parentEl.parentElement.querySelector('.submenu.show');
                // if it exists, then close all of them
                if(opened_submenu){
                  new bootstrap.Collapse(opened_submenu);
                }
            }
        }
    }); // addEventListener
  }) // forEach
}); 

jQuery(".sidebar>.nav>.nav-item>.nav-link").on("click", function(){
  jQuery(".sidebar>.nav>.nav-item>.nav-link.active").each(function (index, element) {
    jQuery(this).removeClass("active");
  });
  //jQuery(".submenu.show").each(function (index, element) {
    //jQuery(this).removeClass("active");
  //});
  jQuery(this).addClass("active");
});

let mybutton = document.getElementById("btn-back-to-top");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (
    document.body.scrollTop > 20 ||
    document.documentElement.scrollTop > 20
  ) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}
// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);

function backToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}